// @flow

import React from 'react';
import Tooltip from '../../../../components/Tooltip';

type Props = {
  tooltipContent?: ?React.Node,
  image: string,
  value: string | number | React.Node,
  subValue?: string | number | React.Node,
  label: string | React.Node,
  showTooltip?: boolean,
  subValueClassName?: string,
  subTitle?: string,
}

class MarketingFact extends React.PureComponent<Props> {
  static defaultProps = {
    tooltipContent: null,
    showTooltip: false,
  };

  render() {
    if (!this.props.value || this.props.value === 'N/A') {
      return false;
    }
    return (
      <div className="marketing-value-container">
        {this.props.tooltipContent && this.props.showTooltip && (
          <Tooltip>
            {this.props.tooltipContent}
          </Tooltip>
        )}
        <div className="marketing-value">
          <div className="rounded-image">
            <img src={this.props.image} alt="Loyalty Cards" />
          </div>
          <div className="marketing-value-description">
            <div className="marketing-value-value">
              {this.props.value}
              {this.props.subValue && (
                <div className={`subvalue ${this.props.subValueClassName || ''}`}>
                  {this.props.subValue}
                </div>)}
            </div>
            <div className="marketing-value-label">
              {this.props.label}
              {this.props.subTitle && (
                <div className="subtitle">
                  {this.props.subTitle}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MarketingFact;
